export class Recommendation {
  public key: number | string;
  public name: string;
  public image?: string | null | undefined;

  public pair?: string | null | undefined;
  public option?: string | null | undefined;

  public age_min?: number | string | null;
  public age_max?: number | string | null;
  public hours_min?: number | string | null;
  public hours_max?: number | string | null;
  public percent_outdoors_min?: number | string | null;
  public percent_outdoors_max?: number | string | null;

  public type_1?: string | null | undefined;
  public type_2?: string | null | undefined;
  public type_3?: string | null | undefined;
  public type_4?: string | null | undefined;
  public type_5?: string | null | undefined;
  public;

  public ignore_types?: number | string | null;

  public symptom_1?: string | null | undefined;
  public symptom_2?: string | null | undefined;
  public symptom_3?: string | null | undefined;
  public symptom_4?: string | null | undefined;
  public symptom_5?: string | null | undefined;
  public symptom_6?: string | null | undefined;

  public title?: string | null | undefined;

  public feature_1?: string | null | undefined;
  public feature_2?: string | null | undefined;
  public feature_3?: string | null | undefined;
  public feature_4?: string | null | undefined;
  public feature_5?: string | null | undefined;

  public activity_1: string | null | undefined;
  public activity_2: string | null | undefined;
  public activity_3: string | null | undefined;
  public activity_4: string | null | undefined;

  constructor(recommendation: Recommendation) {
    // empty strings to null
    for (const key in recommendation) {
      if (recommendation.hasOwnProperty(key)) {
        this[key] = recommendation[key] === '' || recommendation[key] === undefined ? null : recommendation[key];
      }
    }

    // optional numbers to number or null
    ['key', 'age_min', 'age_max', 'hours_min', 'hours_max', 'percent_outdoors_min', 'percent_outdoors_max', 'ignore_types'].forEach(
      (key: string) => {
        if (typeof this[key] === 'string') {
          this[key] = +recommendation[key];
        }
      }
    );
  }
}

export class CustomerData {
  public firstName?: string | number;
  public lastName?: string | number;
  public email?: string | number;
  public doctor?: string | number;
  public phone?: string | number;
  public downloadURL?: string;
  public message?: string;
  constructor(customerData?: CustomerData) {
    if (customerData) {
      if (customerData.firstName) this.firstName = customerData.firstName;
      if (customerData.lastName) this.lastName = customerData.lastName;
      if (customerData.email) this.email = customerData.email;
      if (customerData.doctor) this.doctor = customerData.doctor;
      if (customerData.phone) this.phone = customerData.phone;
      if (customerData.downloadURL) this.downloadURL = customerData.downloadURL;
      if (customerData.message) this.message = customerData.message;
    }
  }
}



// WEBPACK FOOTER //
// ./src/types/session.type.ts